// this is in its own file to avoid circular dependencies.

import {selfTqk} from "../rpc/webrpc-client.gen.ts";
import {autologinTqk} from "../auth/authenticator.tsx";

export const bedrockTqKeys = [
    selfTqk,
    autologinTqk,
];

